import { getRoutePermissions } from '~/modules/common/permissions';
import { useRedirectToProjectResourcingLink } from '~/modules/resource-management/ResourcingOverview/components/ResourceRequestRemindersCard/hooks';
import { OVERVIEW_UNITS_ENUM } from '~/modules/resource-management/common/enums';
import { useMeContext } from '~/modules/me';
import useNavigateToQuickAllocation from './useNavigateToQuickAllocation';

const DECIMAL_PLACES = 2;

export const RESOURCING_PLAN_STATUS_PATH = {
  PENDING: 'PENDING',
  PROPOSED: 'PROPOSED',
  TOBEHIRED: 'TOBEHIRED'
};

const getMessageId = ({ displayUnit }) =>
  displayUnit === OVERVIEW_UNITS_ENUM.FTE
    ? 'resourceManagementDashboard.actionItems.fteValue'
    : displayUnit === OVERVIEW_UNITS_ENUM.PERCENTAGE
    ? 'resourceManagementDashboard.actionItems.percentValue'
    : 'resourceManagementDashboard.actionItems.hoursValue';

const getFormattedValue = ({ value, valueMessageId, formatMessage }) => {
  return value != null
    ? formatMessage(
        { id: valueMessageId },
        { value: value.toFixed(DECIMAL_PLACES) }
      )
    : '-';
};

export const useGetFormattedActionItemsContent = ({
  colourClasses,
  formatMessage,
  actionItemValues,
  displayUnit
}) => {
  const {
    bench,
    overAllocated,
    pendingRequests,
    proposedResources,
    toBeHired
  } = actionItemValues;

  const valueMessageId = getMessageId({ displayUnit });
  const me = useMeContext();
  const { canViewResourcing } = getRoutePermissions(me);

  const navigateToQuickAllocation = useNavigateToQuickAllocation();

  return [
    {
      key: 'bench',
      title: formatMessage({
        id: 'resourceManagementDashboard.actionItems.bench'
      }),
      formattedValue: getFormattedValue({
        value: bench,
        valueMessageId,
        formatMessage
      }),
      className: colourClasses.benchCard,
      link: '#',
      showAsLink: canViewResourcing,
      onClick: navigateToQuickAllocation
    },
    {
      key: 'overAllocated',
      title: formatMessage({
        id: 'resourceManagementDashboard.actionItems.overAllocated'
      }),
      formattedValue: getFormattedValue({
        value: overAllocated,
        valueMessageId,
        formatMessage
      }),
      className: colourClasses.overAllocatedCard,
      link: '#',
      showAsLink: canViewResourcing,
      onClick: navigateToQuickAllocation
    },
    {
      key: 'pendingRequests',
      title: formatMessage({
        id: 'resourceManagementDashboard.actionItems.pendingRequests'
      }),
      formattedValue: getFormattedValue({
        value: pendingRequests,
        valueMessageId,
        formatMessage
      }),
      className: colourClasses.pendingRequestsCard,
      link: useRedirectToProjectResourcingLink(
        RESOURCING_PLAN_STATUS_PATH.PENDING
      ),
      showAsLink: canViewResourcing
    },
    {
      key: 'proposedResources',
      title: formatMessage({
        id: 'resourceManagementDashboard.actionItems.proposedResources'
      }),
      formattedValue: getFormattedValue({
        value: proposedResources,
        valueMessageId,
        formatMessage
      }),
      className: colourClasses.proposedResourcesCard,
      link: `/resourcing/${RESOURCING_PLAN_STATUS_PATH.PROPOSED}`,
      showAsLink: canViewResourcing
    },
    {
      key: 'toBeHired',
      title: formatMessage({
        id: 'resourceManagementDashboard.actionItems.toBeHired'
      }),
      formattedValue: getFormattedValue({
        value: toBeHired,
        valueMessageId,
        formatMessage
      }),
      className: colourClasses.toBeHiredCard,
      link: useRedirectToProjectResourcingLink(
        RESOURCING_PLAN_STATUS_PATH.TOBEHIRED
      ),
      showAsLink: canViewResourcing
    }
  ];
};
